import React, { useMemo, Fragment, useState } from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { ArrayItems, Form, Input, FormItem } from '@formily/antd'
import { createForm, Form as FormCore } from '@formily/core'
import { observer } from '@formily/reactive-react'
import { createSchemaField, useExpressionScope  } from '@formily/react'
import { ValueInput } from '../ValueInput'
import { ClickInput } from '../ClickInput'
import { usePrefix, TextWidget } from '@designable/react'
import { Header } from './Header'
import { traverseTree } from './shared'
import { ITreeDataSource } from './types'
import './styles.less'

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    ArrayItems,
    ValueInput,
  },
})

const mappingObject = {
  key: "唯一标识",
  label: '标题',
  clickProps: "点击事件",
  clickCustomEventProps: "事件能力",
  icon: "图标"
}

export interface IDataSettingPanelProps {
  treeDataSource: ITreeDataSource
  allowExtendOption?: boolean
  effects?: (form: FormCore<any>) => void
}

export const DataSettingPanel: React.FC<IDataSettingPanelProps> = observer(
  (props) => {
    const { allowExtendOption, effects } = props
    const [hasChildren, setHasChildren] = useState(false);
    const $scope = useExpressionScope();
    const prefix = usePrefix('data-source-setter')
    const form = useMemo(() => {
      let values: any
      traverseTree(props.treeDataSource.dataSource, (dataItem: any) => {
        if (dataItem.key === props.treeDataSource.selectedKey) {
          setHasChildren(dataItem.children?.length > 0)
          if (!dataItem.map.some(item => item.label === 'icon')) {
            dataItem.map.push({label: 'icon', value: undefined})
          }
          if (!dataItem.map.some(item => item.label === 'clickCustomEventProps')) {
            dataItem.map.push({label: 'clickCustomEventProps', value: {}})
          }
          values = dataItem
        }
      })
      return createForm({
        values,
        effects: effects,
      })
    }, [
      props.treeDataSource.selectedKey,
      props.treeDataSource.dataSource.length,
    ])
    if (!props.treeDataSource.selectedKey)
      return (
        <Fragment>
          <Header
            title={
              <TextWidget token="SettingComponents.DataSourceSetter.nodeProperty" />
            }
            extra={null}
          />
          <div className={`${prefix + '-layout-item-content'}`}>
            <TextWidget token="SettingComponents.DataSourceSetter.pleaseSelectNode" />
          </div>
        </Fragment>
      )
    return (
      <Fragment>
        <Header
          title='节点属性（父节点无需配置事件）'
          extra={
            (allowExtendOption) ? (
              <Button
                type="text"
                onClick={() => {
                  form.setFieldState('map', (state) => {
                    state.value.push({})
                  })
                }}
                //@ts-ignore
                icon={<PlusOutlined />}
              >
                <TextWidget token="SettingComponents.DataSourceSetter.addKeyValuePair" />
              </Button>
            ) : null
          }
        />
        <div className={`${prefix + '-layout-item-content'}`}>
          <Form form={form} labelWidth={100} wrapperWidth={320} >
            <SchemaField scope={{...$scope, mappingObject}}>
              <SchemaField.Array name="map" x-component="ArrayItems">
                <SchemaField.Object
                  x-decorator="ArrayItems.Item"
                  x-decorator-props={{ type: 'divide' }}
                >
                  <SchemaField.String
                    title="键名"
                    x-decorator="FormItem"
                    x-disabled={!allowExtendOption}
                    name="label"
                    x-hidden={true}
                    x-component="Input"
                  />
                  <SchemaField.String
                    title="键值"
                    x-decorator="FormItem"
                    name="value"
                    x-component={ClickInput}
                    x-component-props={{
                      hideClick: hasChildren 
                    }}
                    x-reactions={{
                      dependencies: ['.label'],
                      fulfill: {
                        state: {
                          componentProps: {
                            type: '{{ $deps[0] }}' 
                          },
                          title: '{{ mappingObject[$deps[0]] }}'
                        },
                      }
                    }}
                  />
                  <SchemaField.Void
                    x-component="ArrayItems.Remove"
                    x-visible={allowExtendOption}
                    x-component-props={{
                      style: {
                        margin: 5,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      },
                    }}
                  />
                </SchemaField.Object>
              </SchemaField.Array>
            </SchemaField>
          </Form>
        </div>
      </Fragment>
    )
  }
)
